import { useMemo } from "react";

import { useLocaleContext } from "../../i18n/locale-context";
import { Event } from "./types";

export function useEventDates(
  event: Pick<
    Event,
    "startDateEvent" | "endDateEvent" | "startDateSubscription" | "endDateSubscription"
  >
) {
  const { locale } = useLocaleContext();
  const startDate = useMemo(() => new Date(event.startDateEvent), [event.startDateEvent]);
  const endDate = useMemo(() => new Date(event.endDateEvent), [event.endDateEvent]);
  const startDateSub = useMemo(
    () => new Date(event.startDateSubscription),
    [event.startDateSubscription]
  );
  const endDateSub = useMemo(
    () => new Date(event.endDateSubscription),
    [event.endDateSubscription]
  );
  const now = useMemo(() => new Date().getTime(), []);
  const isSubscriptionOpen = now >= startDateSub.getTime() && now <= endDateSub.getTime();
  const isPastEvent = now > endDate.getTime();

  const formattedDateRange = Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).formatRange(startDate, endDate);

  const formattedDateTimeRange = Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    hour: "numeric",
    minute: "numeric",
  }).formatRange(startDate, endDate);

  return useMemo(
    () => ({
      startDate,
      endDate,
      formattedDateRange,
      formattedDateTimeRange,
      isSubscriptionOpen,
      isPastEvent,
    }),
    [
      endDate,
      formattedDateRange,
      formattedDateTimeRange,
      isPastEvent,
      isSubscriptionOpen,
      startDate,
    ]
  );
}
